import { render, staticRenderFns } from "./ae-exclusions.vue?vue&type=template&id=aded6112&scoped=true"
import script from "./ae-exclusions.vue?vue&type=script&lang=js"
export * from "./ae-exclusions.vue?vue&type=script&lang=js"
import style0 from "./ae-exclusions.vue?vue&type=style&index=0&id=aded6112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aded6112",
  null
  
)

export default component.exports